export const DRAG_ELEMENT = '↔️ DRAG_ELEMENT'
export const RESIZE = '↔️ RESIZE'
